import React, { Component } from 'react';
import Grid from '../../Utils/GridEnvioProduccionSDatos';
import Swal from 'sweetalert2';

class DetalleIngresoSDatos extends Component{
    
    render(){
        const { loader, detalle } = this.props;
        const cellEditProp = {
            mode: 'click'
        };
        function validarDosDecimales(value) {
            let strValue = String(value);
    
            if (isNaN(value) || value === '') {
                Swal.fire({
                    title: 'Envío',
                    text: 'Debe ingresar un número válido en precio',
                    type: 'error',
                });
                return 'Debe de ingresar un número válido en precio';
            }

            let splitVal = strValue.split('.');

            if (splitVal.length === 1) {
                return true;
            }

            if (splitVal.length === 2 && splitVal[1].length <= 2) {
                return true;
            }

            Swal.fire({
                title: 'Factura',
                text: 'El precio no puede tener más de 2 decimales',
                type: 'error',
            });
            
            return 'Debe de ingresar 2 decimales en precio';
        }

        return(
            <React.Fragment>
                {detalle &&
                <Grid 
                    hover 
                    striped 
                    data={detalle} 
                    loading={loader}
                    cellEdit={ cellEditProp }
                    footer
                    headerStyle={ { background: 'black' } } 
                >
                <TableHeaderColumn
                    isKey
                    dataField="tCantidad"
                    dataAlign='right'
                    width="200"
                    headerAlign="center"
                    dataSort
                    editable={ false }
                    dataFormat={(cell, row)=>{
                        return new Intl.NumberFormat("en-US",{minimumFractionDigits: 6}).format(cell);
                    }}
                    thStyle={
                        {color: 'white'}}
                    tdStyle={
                        {color: 'white'}}
                >
                    Cantidad
                </TableHeaderColumn>
                <TableHeaderColumn
                    dataField="sku"
                    width="200"
                    dataSort
                    editable={ false }
                    thStyle={
                        {color: 'white'}}
                    tdStyle={
                        {color: 'white'}}
                    >
                    SKU
                </TableHeaderColumn>
                <TableHeaderColumn
                    dataField="productoN"
                    dataSort
                    editable={ false }
                    thStyle={
                        {color: 'white'}}
                    tdStyle={
                        {color: 'white'}}
                    >
                    Producto
                </TableHeaderColumn>
                <TableHeaderColumn
                    dataField="precio"
                    dataAlign='right'
                    width="200"
                    headerAlign="center"
                    dataSort
                    editable={{ type:'number', validator: validarDosDecimales }}
                    dataFormat={(cell, row)=>{
                        return new Intl.NumberFormat("en-US",{minimumFractionDigits: 2}).format(cell);
                    }}
                    thStyle={
                        {color: 'white'}}
                    tdStyle={
                        {color: 'white'}}
                >
                    Precio
                </TableHeaderColumn>
                <TableHeaderColumn
                    dataField="total"
                    dataAlign='right'
                    width="200"
                    headerAlign="center"
                    dataSort
                    editable={ false }
                    dataFormat={(cell, row)=>{
                        return new Intl.NumberFormat("en-US",{minimumFractionDigits: 2}).format(row.cantidad*row.precio);
                    }}
                    thStyle={
                        {color: 'white'}}
                    tdStyle={
                        {color: 'white'}}
                >
                    Total
                </TableHeaderColumn>
                </Grid>
                }
            </React.Fragment>
        );
    }
}

export default DetalleIngresoSDatos;
